import { FC, useEffect, useState } from "react";
import { SpecialtyProviderCountModel } from "@app/projects/network-assessment/provider-hub/interfaces";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";

interface ReadyForReviewSpecialtyListProps {
  data: SpecialtyProviderCountModel[];
  onSpecialtyClick: (specialtyGroupCode: string) => void;
  qesTestId: string;
}

const ReadyForReviewSpecialtyList: FC<ReadyForReviewSpecialtyListProps> = (props: ReadyForReviewSpecialtyListProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (props.data.length <= 5) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [props.data]);

  const displayData = expanded ? props.data : props.data.slice(0, 5);

  return (
    <div className="pci-dashboard__ready-for-review-widget-list">
      <div className="pci-dashboard__ready-for-review-widget-list--header">
        <b>Specialties with the most providers meeting these criteria</b>
      </div>

      {displayData.map(({ providerCount, specialtyCode, specialtyName }, i) => (
        <div className="pci-dashboard__ready-for-review-widget-list--item" key={specialtyCode}>
          <div className="pci-dashboard__ready-for-review-widget-list--rank">{i + 1}</div>
          <div className="pci-dashboard__ready-for-review-widget-list--specialty">{specialtyName}</div>
          <QESButton
            onClick={() => props.onSpecialtyClick(specialtyCode)}
            qesType="secondary"
            qesTestId={`${props.qesTestId}--view-by-specialty-btn--${specialtyCode}`}
          >
            <b>{providerCount.toLocaleString()} providers <QesIcon iconName={QesIcons.ChevronRight} isDecorative={true} className="align-text-top" /></b>
          </QESButton>
        </div>
      ))}

      {!expanded && (
        <QESButton
          className="pci-dashboard__ready-for-review-widget-list--load-all"
          onClick={() => setExpanded(true)}
          qesType="secondary"
          qesTestId={`${props.qesTestId}--load-all-btn`}
        >
          <b>Load All</b>
        </QESButton>
      )}
    </div>
  );
};

export default ReadyForReviewSpecialtyList;
